import { Group, Text } from '@mantine/core';

import { IconFigmaAlertTriangle } from '@/assets/icons';

interface FormErrorMessageProps {
  message: string;
}

export const FormErrorMessage = ({ message }: FormErrorMessageProps) => (
  <Group
    gap={10}
    px={14}
    py={12}
    wrap="nowrap"
    style={{
      borderRadius: 10,
      backgroundColor: 'var(--color-status-danger-soft)',
      color: 'var(--color-status-danger)'
    }}
  >
    <IconFigmaAlertTriangle size={16} />
    <Text fz={14} fw={600} style={{ color: 'inherit' }}>
      {message}
    </Text>
  </Group>
);
